import Http from "./base-http";

class Position extends Http {
  deletePositions(id) {
    return this.destroy(id);
  }
  addPosition(variables) {
    return this.create(variables);
  }
  getAssignedPermissions(positionId){
    return this.get(`${positionId}/permissions`)
  }
  addPermissions(positionId, permissions){
    this.create(`${positionId}/permissions`, permissions)
  }
  deletePermissions(positionId){
    this.create(`${positionId}/permissions`, [])
  }
}

const positionObj = new Position({
  modelUrlPrefix : "position"
});

export default positionObj;
